export const verifyEmailConfigs = {
  OTP_LENGTH: 6,
};
